/**
 * Event display constants shared across applications.
 */
import type { EventStatus, EventType } from "../types/events";

export const EVENT_STATUSES = [
  "WAITLISTED",
  "OPEN",
  "SKIPPED",
  "CLOSED",
  "CANCELLED",
  "DELETED",
] as const satisfies readonly EventStatus[];

export const EVENT_STATUS_LABELS = {
  WAITLISTED: "Waitlisted",
  OPEN: "Open",
  SKIPPED: "Skipped",
  CLOSED: "Complete",
  CANCELLED: "Cancelled",
  DELETED: "Deleted",
} as const satisfies Record<EventStatus, string>;

export const EVENT_STATUS_FILTER_STATUSES = [
  "OPEN",
  "CLOSED",
  "SKIPPED",
] as const satisfies readonly Exclude<
  EventStatus,
  "DELETED" | "WAITLISTED" | "CANCELLED"
>[];

export const EVENT_STATUS_FILTER_OPTIONS = EVENT_STATUS_FILTER_STATUSES.map(
  (id) => ({
    id,
    name: EVENT_STATUS_LABELS[id],
  }),
) satisfies readonly { id: Exclude<EventStatus, "DELETED">; name: string }[];

export const EVENT_TYPES = [
  "VISIT",
  "TODO",
  "MEETING",
  "MAINTENANCE",
  "WORK_REQUEST",
] as const satisfies readonly EventType[];

export const EVENT_TYPE_LABELS = {
  VISIT: "Visit",
  TODO: "To-do",
  MEETING: "Meeting",
  MAINTENANCE: "Maintenance",
  WORK_REQUEST: "Work request",
} as const satisfies Record<EventType, string>;

export const EVENT_TYPE_OPTIONS = EVENT_TYPES.map((id) => ({
  id,
  name: EVENT_TYPE_LABELS[id],
})) satisfies readonly { id: EventType; name: string }[];
